import CourseList from './pages/CourseList.tsx';
import Contact from './pages/Contact.tsx';
import About from './pages/About.tsx';
import CoursePage from './pages/CoursePage.tsx';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PageNotFound from './pages/PageNotFound.tsx';
import Home from './pages/Home.tsx';
import UsageGuide from './pages/UsageGuide.tsx';
import ReactGA from 'react-ga4';
import { Analytics } from "@vercel/analytics/react"

const App = () => {

  const TRACKING_ID = 'G-T7TYKF9FZ6';
  ReactGA.initialize(TRACKING_ID);
  ReactGA.send({hitType: 'pageview', page: "/"});


  return (
    <BrowserRouter>
      <Routes>
        <Route path="/course/*" element={<CoursePage />} />
        <Route path="/" exact element={<Home />} />
        <Route path="/courses/*" element={<CourseList/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/usage-guide" element={<UsageGuide/>} />
        <Route path="*" element={<PageNotFound/>} />
      </Routes>
      <Analytics />
    </BrowserRouter>
  )
};

export default App;
